import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import SeoHead from "./SiteSeo";
import SiteLayout from "./SiteLayout";
import { SmartLink } from "./SiteHeader";
import { Intro, FinalCta } from "./sections";
import { API, usePlaybooks } from "./playbookData";

export function PlaybookTile({ p, compact = false }) {
  return (
    <SmartLink className={`pb-tile${compact ? " compact" : ""}`} href={`/playbooks/${p.slug}/`} data-testid={`playbook-tile-${p.slug}`}>
      <div className="pb-cover">{p.cover_url && <img src={`${API}${p.cover_url}`} alt={`${p.label} cover`} loading="lazy" />}</div>
      <div className="pb-tile-body">
        <span className="tag">{p.audience} · {p.pages} pages</span>
        <h3>{p.label}</h3>
        {!compact && <p>{p.tagline}</p>}
        <span className="tool-link">{compact ? "Open →" : "Read & download →"}</span>
      </div>
    </SmartLink>
  );
}

export default function PlaybooksHub() {
  const list = usePlaybooks();
  const ld = { "@context": "https://schema.org", "@type": "CollectionPage", name: "Mortgage Playbooks", url: "https://www.hellomortgage.ca/playbooks/",
    hasPart: (list || []).map((p) => ({ "@type": "DigitalDocument", name: p.label, url: `https://www.hellomortgage.ca/playbooks/${p.slug}/` })) };
  return (
    <SiteLayout>
      <SeoHead title="Mortgage Playbooks — Free Guides for Alberta Buyers & Homeowners | Hello Mortgage Team" description="Six free mortgage playbooks: Mortgage 101, the document checklist, guides for educators, healthcare and hospitality workers, and a plain-English refinancing guide. Read online or download the PDF." path="/playbooks/" />
      <Helmet><script type="application/ld+json">{JSON.stringify(ld)}</script></Helmet>
      <section className="hero pb-hero" data-testid="playbooks-hub">
        <div className="wrap">
          <div className="eyebrow">Mortgage Playbooks · free, no strings</div>
          <h1 style={{ fontSize: "clamp(3rem,6vw,5.4rem)" }}>The guides we hand our own clients.</h1>
          <p>Written for real Alberta careers and real decisions — not lender brochures. Read them online, download the PDF, and call us when a question turns into a plan.</p>
        </div>
      </section>
      <section className="pb-library">
        <div className="wrap">
          <Intro eyebrow="Pick your playbook" heading="Start with the one that sounds like you." text="Buying your first place, gathering paperwork, working shifts or tips, or wondering whether a refinance is worth it — there’s a playbook for that." />
          <div className="pb-grid" data-testid="playbook-grid">{(list || []).map((p) => <PlaybookTile p={p} key={p.slug} />)}</div>
        </div>
      </section>
      <FinalCta text="Playbooks answer the general questions. Your file answers the rest. Start with a free conversation — no pressure, no mortgage-speak." />
    </SiteLayout>
  );
}
